import React, { useState } from "react";
import 'react-datepicker/dist/react-datepicker.css'
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from "reactstrap";

const ButtonHelper = ({
        actionReportButon=false,
        reportButons=false,
        actionAddButon=false,
        addButon=true
    }) => {

    const [reportDrodown, setReportDrodown] = useState(false)

    return (
        <>
            <div className="col-sm-3 ms-auto float-end">
            {addButon&&
                <button className="btn btn-sm btn-primary float-end ms-2" onClick={() => actionAddButon()}><i className="fas fa-solid fa-plus"></i> Agregar</button>
            }
           
            {reportButons &&
                <Dropdown
                className="float-end"
                    isOpen={reportDrodown}
                    toggle={() => setReportDrodown(!reportDrodown)}
                >
                    <DropdownToggle tag="button" className="btn btn-secondary btn-sm w-100">
                        <i className="fa fa-file-export"></i> Exportar <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem to="#" onClick={() => actionReportButon(1)}><i className="fa fa-file-excel"></i> Excel</DropdownItem>
                        <DropdownItem to="#" onClick={() => actionReportButon(2)}><i className="fa fa-file-pdf"></i> PDF</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            }
            </div>
        </>
    );
};

export default ButtonHelper;
